import type {ReactNode} from "react";
import {createRef, useState} from "react";
import {defaultTheme} from "../../styles/themes/color-themes.css";
import {Box, Col, css} from "../../ui/Box";
import ErrorBoundary from "../../utils/ErrorBoundary";
import {makeScrollable} from "../../utils/makeScrollable";
import type {AppShellRefs} from "./app-shell-context";
import {AppShellContext} from "./app-shell-context";

type AppShellProps = {header?: ReactNode; children: ReactNode; footer?: ReactNode};
const AppShell = ({children, header, footer}: AppShellProps) => {
  const [refs] = useState<AppShellRefs>(() => ({shellRef: createRef(), contentRef: createRef()}));
  return (
    <AppShellContext.Provider value={refs}>
      <div
        ref={refs.shellRef}
        vaul-drawer-wrapper=""
        className={css(
          {
            display: "flex",
            flexDir: "column",
            flex: "auto",
            maxWidth: "_appShellWidth",
            width: "100%",
            ml: "auto",
            mr: "auto",
            elevation: "200",
            bg: "background",
            color: "primary",
            overflow: "hidden",
          },
          defaultTheme
        )}
      >
        {header}
        <Box
          ref={refs.contentRef}
          flex="auto"
          relative
          className={makeScrollable({dir: "vertical"})}
        >
          <Col absolute top="0" left="0" right="0" minHeight="100%">
            <ErrorBoundary>{children}</ErrorBoundary>
          </Col>
        </Box>
        {footer}
      </div>
    </AppShellContext.Provider>
  );
};

export default AppShell;
